import { render, staticRenderFns } from "./PiecesListCard.vue?vue&type=template&id=406c5f14&"
import script from "./PiecesListCard.vue?vue&type=script&lang=js&"
export * from "./PiecesListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports